import React, { useEffect, useState, useCallback } from 'react';
import { Box, TextField, Button, Stack} from '@mui/material';

const AddUser = ({show, setShow, addNewTenant}) => {
    const [mobileNo, setMobileNo] = useState("")
    const [name, setName] = useState("")
    const resetVals = () => {
        setMobileNo("")
        setName("")
    }
    if (show) {
        return (
            <Box>
                <TextField sx={{mb:1}} variant="outlined" label="Phone No" value={mobileNo} onChange={(e)=>{setMobileNo(e.target.value)}}/>
                <TextField sx={{mb:1}} variant="outlined" label="Name" value={name} onChange={(e)=>{setName(e.target.value)}}/>
                <Stack direction="row">
                    <Button sx={{mr:1}} onClick={()=>{addNewTenant(mobileNo, name)}}>Add</Button>
                    <Button sx={{mr:1}} onClick={()=>{setShow(false); resetVals(); }}>Cancel</Button>
                </Stack>
            </Box>
        )
    }
    return null;
}

export default AddUser;